/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import React, { useEffect, useState, useContext } from 'react';
import {
  Card,
  Icon,
  Tooltip,
  Progress,
  Loader,
  Button,
  Modal
} from '@scuf/common';
// import i18next from 'i18next';
import './EnergyStarWidget.scss';
import useConnectorAndDynamicProps from '../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import { IEnergyStarProps } from './EnergyStarProps';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../locales/en-US/descriptors';
import { ApiContext } from '../../context/ApiContext';
import { Notification } from '@scuf/common';
import { EnergyStarErrorModel } from './EnergyStarErrorModel';
import moment from 'moment';
import withLoadingStatus from '../shared/StatusWrappers/LoadingStatus';
import withErrorStatus from '../shared/StatusWrappers/ErrorStatus';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import { isObjectOrArrayAndEmpty } from '../shared/Utils/Utils';
import ConnectionError from '../shared/ErrorComponents/ConnectionError';
import {
  getEnergyEndDateBasedOnSub,
  getEnergyStartDate
} from '../shared/Utils/EnergyUsagesViewDetailsUtils';
import useMounted from '../shared/useMount/useMount';

const EnergyStarContent = (props: IAny) => {
  const d = descriptors.energyStar;
  const e = descriptors.energyManagement;
  const [t] = useTranslation();
  const {
    data,
    onRefresh,
    onEnergyStarViewDetailsClick,
    openModal,
    setOpenModal,
    requestContext,
    currentScore,
    previousDate,
    prevMonth,
    recentMonthScore,
    updatingModalPopUp
  } = props;

  // if (isObjectOrArrayAndEmpty(data)) {
  //   return (
  //     <>
  //     <div className="energySite-Header-container">
  //       <div className="energy-site-left-container">
  //         <div className="energy-score">

  //             <div className="current-score-value">{t(d.NA)}</div>

  //         </div>
  //       </div>
  //     </div>
  //     <div className="certification-energy-progress">
  //       {
  //         <Progress
  //           className={currentScore ? 'green-progress' : 'empty-progress'}
  //           percent={currentScore ? currentScore : 100}
  //           total={100}
  //           size="small"
  //         />
  //       }
  //     </div>
  //     <div>
  //       <span>
  //         {t(d.EnergySubcriptionPeriod)}
  //         {` ${previousDate}`}
  //       </span>
  //     </div>
  //     <div>
  //       <a
  //         href="https://www.energystar.gov/buildings/benchmark/understand_metrics"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         className="link-text"
  //       >
  //         {t(d.LearnText)}
  //       </a>
  //     </div>
  //     {/* </div> */}
  //     {recentMonthScore === 0 || recentMonthScore === undefined ? (
  //       <Notification
  //         className="energy-star-notification"
  //         hasIcon={true}
  //         title={t(d.SomethingWentWrong)}
  //       >
  //         <div>
  //           <span>
  //             {currentScore !== 0 && currentScore !== undefined
  //               ? t(d.EnergyStarNoScoreForLastMonthLabel)
  //               : t(d.ReasonForNoScoreLabel)}
  //           </span>{' '}
  //           <span className="label" onClick={updatingModalPopUp}>
  //             {t(d.ViewReasonForNoScore)}
  //           </span>
  //         </div>
  //       </Notification>
  //     ) : null}
  //     <div className="view-site-details">
  //       <Button
  //         className="link-text"
  //         type="link"
  //         content={t(d.ViewText.defaultMessage.toLocaleUpperCase())}
  //         onClick={() => {
  //           onEnergyStarViewDetailsClick && onEnergyStarViewDetailsClick();
  //         }}
  //       ></Button>
  //     </div>
  //     {openModal && (
  //       <EnergyStarErrorModel
  //         onClose={() => setOpenModal(false)}
  //         requestContext={requestContext}
  //       />
  //     )}
  //   </>
  //   );
  // }
  return (
    <>
      <div className="energySite-Header-container">
        <div className="energy-site-left-container">
          <div className="energy-score">
            {currentScore !== 0 && currentScore !== undefined ? (
              <div className="current-score-value Energy-Star-NA">
                {currentScore}
              </div>
            ) : (
              <div className="current-score-value Energy-Star-NA">
                {t(d.NA)}
              </div>
            )}
            <div className="total-score Energy-Star-NA">
              {t(d.outOfHundred)}
            </div>
          </div>
          <div className="current-score">{t(d.CurrentScore)}</div>
        </div>
      </div>
      <div className="certification-energy-progress">
        {
          <Progress
            className={currentScore ? 'green-progress' : 'empty-progress'}
            percent={currentScore ? currentScore : 100}
            total={100}
            size="small"
          />
        }
      </div>
      <div>
        <span>
          {t(d.EnergySubcriptionPeriod)}
          {` ${previousDate}`}
        </span>
      </div>
      <div>
        <a
          href="https://www.energystar.gov/buildings/benchmark/understand_metrics"
          target="_blank"
          rel="noopener noreferrer"
          className="link-text"
        >
          {t(d.LearnText)}
        </a>
      </div>
      {/* </div> */}
      {recentMonthScore === 0 || recentMonthScore === undefined ? (
        <Notification
          className="energy-star-notification"
          hasIcon={true}
          title={t(d.SomethingWentWrong)}
        >
          <div>
            <span>
              {currentScore !== 0 && currentScore !== undefined
                ? t(descriptors.energyStar.EnergyStarNoScoreNote)
                : // `The Energy Star score displayed is from ${prevMonth}, as the previous month score is unavailable.`
                  t(d.ReasonForNoScoreLabel)}
            </span>{' '}
            <span className="label" onClick={updatingModalPopUp}>
              {t(d.ViewReasonForNoScore)}
            </span>
          </div>
        </Notification>
      ) : null}
      <div className="view-site-details">
        <Button
          className="link-text"
          type="link"
          content={t(d.ViewText)}
          onClick={() => {
            onEnergyStarViewDetailsClick && onEnergyStarViewDetailsClick();
          }}
        ></Button>
      </div>
      {openModal && (
        <EnergyStarErrorModel
          onClose={() => setOpenModal(false)}
          requestContext={requestContext}
        />
      )}
    </>
  );
};

const EnergyStarComponentWithLoader = withLoadingStatus(
  withErrorStatus(EnergyStarContent)
);

const EnergyStarSiteWidget = (props: IEnergyStarProps) => {
  const { requestContext, bearerToken } = props;
  const [previousDate, setPreviousDate] = useState('');
  const [currentScore, setCurrentScore] = useState();
  const [prevMonth, setprevMonth] = useState('');
  const [siteEnergyScore, setSiteEnergyScore] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  const [recentMonthScore, setRecentMonthScore] = useState();
  const updatingModalPopUp = () => {
    setOpenModal(true);
  };

  const [t] = useTranslation();
  const d = descriptors.energyStar;
  const e = descriptors.energyManagement;
  const apiContext = useContext(ApiContext);
  const { onEnergyStarViewDetailsClick } = apiContext;

  const startDate = getEnergyStartDate(
    requestContext.context.startTime!,
    requestContext.context.subscriptionType!
  );
  const endDate = getEnergyEndDateBasedOnSub(
    requestContext.context.subscriptionType!,
    requestContext.context.endTime!,
    requestContext.context.startTime!
  );

  const connectorConfig = {
    name: 'energy-star'
    // options: {
    //   startDate: startDate,
    //   endDate: endDate,
    // }
  };

  const [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig,
    requestContext,
    bearerToken
  });

  const { all, loading, error, status } = dataConnector.data;
  const siteScore: any = all as unknown;
  const isDataAvailable = siteScore ? true : false;
  const [isLoading, setIsLoading] = useState<boolean>(loading);
  const [errorInfo, setErrorInfo] = useState(error);
  const [StatusCode, setStatusCode] = useState<number | null>(status);

  useEffect(() => {
    setIsLoading(loading);
    if ((isDataAvailable || error || status) && !loading) {
      if (isDataAvailable) {
        setSiteEnergyScore(siteScore);
        let sortedResponse = siteScore?.sort(
          (
            a: { month: string | number | Date },
            b: { month: string | number | Date }
          ) => {
            return new Date(a.month).getTime() - new Date(b.month).getTime();
          }
        );
        let latestmonthWithScore = sortedResponse?.findLast(
          (item: any) =>
            item.energyStarMetricsResponse &&
            item.energyStarMetricsResponse.energyStarScore !== 0
        );
        setPreviousDate(getPreviousMonthDate());
        let recentMonthScore = sortedResponse?.find(
          (item: any) =>
            moment(item.month).month() ===
            moment()
              .subtract(1, 'month')
              .month()
        );
        setRecentMonthScore(
          recentMonthScore && recentMonthScore?.energyStarMetricsResponse
            ? recentMonthScore?.energyStarMetricsResponse?.energyStarScore
            : 0
        );
        setprevMonth(moment(latestmonthWithScore?.month).format('MMM YYYY'));
        setCurrentScore(
          latestmonthWithScore &&
            latestmonthWithScore?.energyStarMetricsResponse
            ? latestmonthWithScore?.energyStarMetricsResponse?.energyStarScore
            : 0
        );
      }
      setErrorInfo(error);
      setStatusCode(status);
    }
  }, [isDataAvailable, loading, status]);
  const onRefresh = () => dataConnector?.actions?.getAll();
  // dataConnector && dataConnector.actions && dataConnector.actions.getAll();
  const isMounted = useMounted();
  useEffect(() => {
    if (isMounted) {
      dataConnector?.actions?.getAll();
    }
  }, [requestContext]);
  const getPreviousMonthDate = () => {
    let lastDayPrevMonth = moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('ddd MMM D YYYY');
    return lastDayPrevMonth;
  };

  return (
    <>
      <Card>
        <Card.Header className="certification-energy-site-header-container">
          <div className="energy-site-card-title">
            {t(d.EnergyStarTitle)}
            <Tooltip
              element={<Icon root="common" name="badge-info" size="small" />}
              event="hover"
              header={t(d.EnergyTooltipHeader)}
              content={t(d.EnergyTooltipContent)}
              position="right center"
              size="small"
            />
          </div>{' '}
          <div className="right-site-container">
            <span className="trademark-wrapper">®</span>
            <img src={require('../../images/EnergyStarLogo.svg')}></img>
          </div>
        </Card.Header>

        <Card.Content className="certification-energy-site-content-container">
          <EnergyStarComponentWithLoader
            loading={isLoading}
            error={errorInfo}
            statusCode={StatusCode}
            onRefresh={onRefresh}
            data={siteEnergyScore}
            loadingText={t(e.LOADING)}
            title={t(e.CONNECTIONERRORTITLE)}
            noDataMessage={t(e.NODATAAVAILABLE)}
            connectionErrorMessage={t(e.CONNECTIONERROR)}
            onEnergyStarViewDetailsClick={onEnergyStarViewDetailsClick}
            setOpenModal={setOpenModal}
            openModal={openModal}
            requestContext={requestContext}
            currentScore={currentScore}
            previousDate={previousDate}
            prevMonth={prevMonth}
            recentMonthScore={recentMonthScore}
            updatingModalPopUp={updatingModalPopUp}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default EnergyStarSiteWidget;
